import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signup } from '../services/authService';  // Import the signup service
import '../signup.css';  // Optionally, include a CSS file

const SignupPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');  // To store the error message
  const [loading, setLoading] = useState(false);  // Track loading state
  const [showPopup, setShowPopup] = useState(false); // State for popup visibility
  const [popupMessage, setPopupMessage] = useState(''); // Message for the popup
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    const userData = { name, email, phone, password };
    
    // Start loading
    setLoading(true);

    try {
      // Attempt to signup the user
      await signup(userData);
      
      // Show success message and redirect to login page after successful signup
      setPopupMessage('Signup successful! Please login.');
      setShowPopup(true); // Show the popup on success
      //alert('Signup successful! Please login.');
      //navigate('/login');
    } catch (error) {
      console.error('Signup Error:', error);

      // Detailed error handling
      if (error.response) {
        // The server responded with a status code other than 2xx
        if (error.response.status === 400) {
          setErrorMessage('Bad Request. Please check your input fields.');
        } else if (error.response.status === 409) {
          setErrorMessage('User already exists with this email or phone number.');
        } else if (error.response.status === 500) {
          setErrorMessage('Server error. Please try again later.');
        } else {
          setErrorMessage('An unknown error occurred. Please try again.');
        }
      } else if (error.request) {
        // The request was made but no response was received (network issue)
        setErrorMessage('No response from the server. Please check your internet connection.');
      } else {
        // Something else caused the error (unexpected frontend error)
        setErrorMessage(`An unexpected error occurred: ${error.message}`);
      }
    } finally {
      // End loading (whether success or error)
      setLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    navigate('/login'); // Redirect to the login page when popup is closed
  };

  return (
    <div className="signup-container">
      <h2 className="signup-title">Signup</h2>
      <form className="signup-form" onSubmit={handleSignup}>
        <div className="form-group">
          <label className="form-label">Name</label>
          <input
            className="form-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            className="form-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Phone</label>
          <input
            className="form-input"
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <input
            className="form-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="signup-btn">Signup</button>
      </form>

      {/* Display error message if signup fails */}
      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {/* Add a login link for users who already have an account */}
      <div className="login-link-container">
        <p className="login-link-text">Already have an account? <span onClick={() => navigate('/login')} className="login-link">Login here</span></p>
      </div>

      {/* Show the loading message box while the request is in progress */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-box">
            <p className="loading-text">Please wait...</p>
          </div>
        </div>
      )}

      {/* Popup Window */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h4 className="popup-message">{popupMessage}</h4>
            <button className="popup-btn btn-success" onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupPage;
